const Footer = () => {


    return <div className='flex justify-between text-sm container mx-auto border-t p-5 border-slate-200 text-slate-400'>
        <div>&copy; CSS Hero 2022</div>
        <div><a href="//csshero.org">&larr; csshero.org</a></div>
    </div>
}

export default Footer;